import { apiRoute, AUTH_V2 } from '../helpers'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const authService = {
  login,
  change,
  logout,
  refresh,
  register,
  validateSession
}

const baseUrl = apiRoute() + AUTH_V2

function login (user) {
  return fetchWrapper.post(`${baseUrl}/login`, user)
}

function change (passwords) {
  // Uses v2/change-password endpoint as per plan (or keeping as is if not in plan? Plan says v2)
  // Plan for API mentions v2 change password.
  return fetchWrapper.post(`${baseUrl}/change-password`, passwords)
}

function logout () {
  return fetchWrapper.post(`${baseUrl}/logout`, {})
}

function refresh () {
  return fetchWrapper.post(`${baseUrl}/refresh`, {})
}

function register (user) {
  return fetchWrapper.post(`${baseUrl}/register`, user)
}

function validateSession () {
  return fetchWrapper.get(`${baseUrl}/me`)
}
